import * as React from "react";

const CaroPrevMobile = (props) => (
    <svg
        width={props.width ? props.width : "48"}
        height={props.height ? props.height : "48"}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle
            cx={24}
            cy={24}
            r={23.5}
            transform="matrix(-1 0 0 1 48 0)"
            stroke="#1F2022"
        />
        <path
            d="M23.7287 13.4065L13.3305 23.8047L23.7287 34.2029"
            stroke="#1F2022"
        />
        <line
            y1={-0.5}
            x2={21.3323}
            y2={-0.5}
            transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 13.332 23.3594)"
            stroke="black"
        />
    </svg>
);
export default CaroPrevMobile;
